import { render, staticRenderFns } from "./ReadingTypeIcon.vue?vue&type=template&id=53bdadb0&scoped=true&"
import script from "./ReadingTypeIcon.vue?vue&type=script&lang=js&"
export * from "./ReadingTypeIcon.vue?vue&type=script&lang=js&"
import style0 from "./ReadingTypeIcon.vue?vue&type=style&index=0&id=53bdadb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bdadb0",
  null
  
)

component.options.__file = "ReadingTypeIcon.vue"
export default component.exports